import { takeEvery } from 'redux-saga/effects';
import * as _ from 'underscore';

import { DeleteCustomView } from '../../../actions/AppActionTypes';
import { handleDeleteCustomViewAction } from './DeleteCustomViewSaga';

export function* rootCustomViewSaga() {
  yield takeEvery(DeleteCustomView, handleDeleteCustomViewAction);
}
